import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';

import './styles.css';

class SidePanel extends Component {
  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    const { overlay } = this.props;
    if (!overlay) {
      document.body.style.overflow = 'visible';
    }
  }

  render() {
    const { children, onDismiss } = this.props;
    document.body.style.overflow = 'hidden';
    const classNames = 'SidePanel';

    return (
      <CSSTransition
        classNames={classNames}
        in
        appear
        timeout={200}
      >
        <div
          className="SidePanel__overlay"
          onClick={onDismiss}
        >
          <div
            className="SidePanel__content"
            onClick={(e) => { e.stopPropagation(); }}
          >
            {children}
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default SidePanel;
export { default as SidePanelHeader } from './SidePanelHeader';
